import React from 'react';
import { Select } from '@domain-group/fe-blueprint-ui/select';
import {
  DEFAULT_SORT_LABEL,
  SORT_OPTIONS_AGENCIES,
  SORT_OPTIONS_AGENTS,
} from '../search-filter-bar/enums';
import * as styles from './sort-by-select.style';

interface SortBySelectProps {
  isAgency: boolean;
  selectedSortBy: string;
  setSortBy: (sortBy: string) => void;
}

const SortBySelect = ({
  isAgency,
  selectedSortBy,
  setSortBy,
}: SortBySelectProps): JSX.Element => {
  const options = isAgency ? SORT_OPTIONS_AGENCIES : SORT_OPTIONS_AGENTS;

  return (
    <div css={styles.sortBy} data-testid="sort-by-select">
      <span css={styles.label} aria-hidden>
        Sort by
      </span>
      <div css={styles.select}>
        <Select
          instanceId="sort-by-select"
          label="Sort by"
          labelHidden
          appearance="regular"
          stretched
          nowrap
          alignBody="right"
          options={options}
          value={selectedSortBy}
          placeholder={DEFAULT_SORT_LABEL}
          onChange={(selected) => {
            if (selected) {
              setSortBy(selected.value);
            }
          }}
        />
      </div>
    </div>
  );
};

export default SortBySelect;
